import Users from '../views/user/Index.vue'
import Permissions from '../views/user/Permissions.vue'
import Profile from '../views/user/Profile.vue'

import {checkauth} from '../Helper'

// nuovo utente e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const UserCreate = () => import('../views/user/Create.vue');
const UserEdit = () => import('../views/user/Edit.vue');

function auth(to, from, next) {
    checkauth().then(response => {
        if (response) {
            next();
        } else {
            next('/login');
        }
    });
}

export default [
    {
        path: '/users',
        name: 'users',
        component: Users,
        beforeEnter: auth,
    },
    {
        path: '/users/new',
        name: 'user-new',
        component: UserCreate,
        beforeEnter: auth,
    },
    // :id e' l'_id dell'utente (24 caratteri esadecimali): "new" non puo' mai finire qui
    {
        path: '/users/:id([0-9a-fA-F]{24})',
        name: 'user-edit',
        component: UserEdit,
        beforeEnter: auth,
    },
    {
        path: '/permissions',
        name: 'permissions',
        component: Permissions,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },

]
